import withWidth from '@material-ui/core/withWidth';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { globalStyles } from '../style/gotheme';
import Grid from '@material-ui/core/Grid';
import PageRow from './PageRow';

const styles = theme => {
  return Object.assign({
  }, globalStyles)
};

class FAQ extends Component {

  render() {

    const { classes, width } = this.props;
    const isLarge = width === "md" || width === "lg" || width === "xl";

    return (
      <div>
        {isLarge &&
          <div style={{ position: 'absolute', overflow: 'hidden', width: '100%', right: 0 }}>
            <img
              src="/images/GraphologiIcon.svg"
              style={{
                float: 'right',
                height: 764,
                marginTop: '-100px',
                marginRight: -160
              }}
              alt="" />
          </div>
        }
        <PageRow spaceTop={isLarge ? "100px" : "36px"} spaceBottom={isLarge ? "50px" : "0px"} color={isLarge ? null : "#F2F7FF"}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h1" style={{ marginBottom: isLarge ? "100px" : "0px" }}>Frequently Asked Questions</Typography>
            </Grid>
          </Grid>
        </PageRow>
        <PageRow spaceTop={isLarge ? "70px" : "0px"} color="#F2F7FF">
          <div style={{ maxWidth: '624px', margin: '0 auto' }}>
            <Accordion className={classes.accordion}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="body2">Have a question?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Please get in touch. We would love to hear from you.</Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </PageRow>
      </div>
    );
  }
}

export default withWidth()(withStyles(styles)(FAQ));